<template>
    <v-card>
        <v-card-subtitle>Change password</v-card-subtitle>
        <v-divider />
        <v-card-text>
            <v-form ref="form" v-model="isValid">
                <v-text-field
                    filled
                    label="Current password *"
                    prepend-inner-icon="mdi-lock"
                    v-model="params.old_password"
                    v-bind:rules="validation.required"
                    v-bind:type="shouldShowPassword ? 'text' : 'password'"
                    v-bind:append-icon="
                        shouldShowPassword ? 'mdi-eye-off' : 'mdi-eye'
                    "
                    v-on:click:append="
                        () => (shouldShowPassword = !shouldShowPassword)
                    "
                ></v-text-field>
                <v-text-field
                    filled
                    label="New password *"
                    prepend-inner-icon="mdi-lock"
                    v-model="params.new_password"
                    v-bind:rules="validation.required"
                    v-bind:type="shouldShowPassword ? 'text' : 'password'"
                    v-bind:append-icon="
                        shouldShowPassword ? 'mdi-eye-off' : 'mdi-eye'
                    "
                    v-on:click:append="
                        () => (shouldShowPassword = !shouldShowPassword)
                    "
                ></v-text-field>
                <v-text-field
                    filled
                    label="Confirm new password *"
                    prepend-inner-icon="mdi-lock"
                    v-model="params.new_password_confirmation"
                    v-bind:rules="[
                        ...validation.required,
                        ...validation.confirmMatch
                    ]"
                    v-bind:type="shouldShowPassword ? 'text' : 'password'"
                    v-bind:append-icon="
                        shouldShowPassword ? 'mdi-eye-off' : 'mdi-eye'
                    "
                    v-on:click:append="
                        () => (shouldShowPassword = !shouldShowPassword)
                    "
                ></v-text-field>
            </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
            <v-spacer />
            <v-btn
                tile
                color="primary"
                class="mr-2"
                v-on:click="submit"
                v-bind:loading="$store.state.app.loading"
                >Submit</v-btn
            >
        </v-card-actions>
    </v-card>
</template>

<script>
import snackbar from '@/utils/snackbar';

export default {
    data() {
        return {
            params: {
                old_password: null,
                new_password: null,
                new_password_confirmation: null
            },
            isValid: null,
            shouldShowPassword: false,
            validation: {
                required: [v => !!v || 'The field is required'],
                confirmMatch: [
                    v =>
                        v == this.params.new_password ||
                        'The password does not match'
                ]
            }
        };
    },
    methods: {
        submit() {
            if (this.isValid) {
                this.$emit('submit', this.params);
            } else {
                this.$refs.form.validate();
                snackbar.show('Please check the fields.', 'warning');
            }
        }
    }
};
</script>
